import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  base_url = ApiRoutes.Document

  constructor(private http: HttpClient) { }
  getDocumentToken(data: { download_url: string }) {
    let url = `${this.base_url}document_token/`;
    return this.http.post<any>(url, data)
  }

  getDocumentBlob(doc_url: string, doc_token: string) {
    let url = `${environment.baseApiUrl}${doc_url}`
    return this.http.get<Blob>(url, {
      headers: { 'X-DOC-TOKEN': doc_token, },
      observe: 'response',
      responseType: 'blob' as 'json'
    })
  }

  downloadInNewTab(download_url: string) {
    let encodedUrl = encodeURIComponent(download_url);
    let origin = window.location.origin
    console.log("check URL", `${origin}/download/?download_url=${encodedUrl}`)
    window.open(`${origin}/download/?download_url=${encodedUrl}`, '_blank')
  }
}
